import React, { useEffect } from 'react';
import { DataImporter } from '@ingestro/importer-react';

import config from '@epi-config';
import { IngestroImporterProps } from '@epi-models/pages/Beneficiaries';

import { UploadInProgress } from '../UploadInProgress';

import { useIngestroImporter } from './useIngestroImporter';

const { ingestroLicenseKey } = config;

export const IngestroImporter = ({
  groups,
  uploadInProgress,
  setUploadInProgress,
  requestId,
  setRequestId,
  allowNextNavigation
}: IngestroImporterProps) => {
  const {
    asyncGetImportStatus,
    settings,
    stepHandler,
    handleResults,
    onEntryChange
  } = useIngestroImporter({
    groups,
    setUploadInProgress,
    requestId,
    setRequestId,
    allowNextNavigation
  });

  useEffect(() => {
    asyncGetImportStatus();
  }, [requestId]);

  useEffect(() => {
    if (uploadInProgress) {
      let cancelled = false;
      let nextPollTimer: ReturnType<typeof setTimeout> | undefined;

      const pollImportStatus = async () => {
        await asyncGetImportStatus();
        if (!cancelled) {
          nextPollTimer = setTimeout(pollImportStatus, 3000);
        }
      };

      pollImportStatus();

      return () => {
        cancelled = true;
        if (nextPollTimer) {
          clearTimeout(nextPollTimer);
        }
      };
    }
  }, [uploadInProgress]);

  return (
    <>
      {uploadInProgress ? (
        <UploadInProgress />
      ) : (
        <DataImporter
          licenseKey={ingestroLicenseKey || 'no license key'}
          settings={settings as any}
          stepHandler={stepHandler}
          onEntryInit={(_row, rowIndex) => ({
            row_number: { value: rowIndex + 1 }
          })}
          onEntryChange={onEntryChange}
          onCancel={() => {
            return;
          }}
          onResults={handleResults}
        />
      )}
    </>
  );
};
